import { Icon, IconProps } from '@chakra-ui/icons'

export default function MyGroupIcon(props: IconProps) {
  return (
    <Icon
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      color={'#212529'}
      {...props}
    >
      <path
        d="M10.395 4.765a1.012 1.012 0 11-1.43 1.43 1.012 1.012 0 011.43-1.43M7.1 2.959a1.558 1.558 0 11-2.202 2.203A1.558 1.558 0 017.1 2.959M3.033 4.764a1.012 1.012 0 11-1.43 1.43 1.012 1.012 0 011.43-1.43M11.5 9.503v-.548c0-.69-.56-1.25-1.25-1.25h-.4M.499 9.503v-.548c0-.69.56-1.25 1.25-1.25h.4M8.669 9.503v-.8a1.75 1.75 0 00-1.75-1.75h-1.84a1.75 1.75 0 00-1.75 1.75v.8"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  )
}
